@for (field of fields(); track field.name) {
  <orbit-form-field
    [label]="field.label"
    [name]="field.name"
    [selectOptions]="field.selectOptions"
    [inputType]="field.type"
    [controller]="field.controller"
    [errorMessage]="field.errorMessage" />
}
